import axios from "axios";
import { IPlcRequest } from "../model/plc.model";

export class PlcService {
    private static rootUrl = '/plc';
    private static client = axios;

    static async postPlc(request: IPlcRequest): Promise<void> {
        if (this.client) {
            await this.client.post(this.rootUrl, request);
        } else {
            throw new Error('Axios client is not initialized');
        }
    }
    
    /**
     * Sendet einen Testauslösen-Befehl an die PLC
     * @returns Promise mit der Antwort vom Server
     */
    static async sendTestCommand(): Promise<any> {
        const response = await this.client.post(`${this.rootUrl}/test`);
        return response.data;
    }
}
